<template>
  <div class="faq" v-if="load">
    <div class="banner">
      <img :src="banner.cover" alt />
    </div>
    <div class="item-title">
      <h2>常见问题</h2>
    </div>
    <!-- 2 -->
    <div class="row faq-list" v-for="(item,index) in list" :key="index">
      <div class="column small-12 medium-4 large-4">
        <img :src="item.cover" alt />
      </div>
      <div class="column small-12 medium-8 large-8 right-text">
        <div class="title">问题{{index + 1}}</div>
        <h3>{{item.title}}</h3>
        <div v-html="item.content"></div>
      </div>
    </div>
    <!-- 4 -->
    <div class="formInfo">
      <div class="title">如有其他问题，请填写下表问询</div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="姓名" prop="name">
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item ref="name" label="邮箱" prop="email">
          <a-input v-model="form.email" />
        </a-form-model-item>
        <a-form-model-item ref="name" label="电话" prop="tel">
          <a-input v-model="form.tel" />
        </a-form-model-item>
        <a-form-model-item ref="name" label="咨询" prop="record">
          <a-input v-model="form.record" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14 }">
          <div class="column small-12 medium-12 large-12 action-btn">
            <div class="button" @click="resetForm">
              <a href="javascript:;">重置</a>
            </div>
            <div class="button" @click="onSubmit">
              <a href="javascript:;">提交</a>
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { FaqList, FaqRecord } from "@/api/index";
export default {
  components: {},
  data() {
    return {
      load: false,
      banner: null,
      list: null,
      labelCol: { span: 2 },
      wrapperCol: { span: 16 },
      form: {
        name: "",
        email: "",
        tel: "",
        record: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },
        ],
        record: [
          {
            required: true,
            message: "请输入您要咨询的内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          FaqRecord(
            {
              nickname: this.form.name,
              tel: this.form.tel,
              email: this.form.email,
              advice: this.form.record,
            },
            (res) => {
              if (res.code == 0 && res.data === true) {
                this.$message.success("提交成功");
                this.resetForm();
              }
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
  created() {
    FaqList((res) => {
      this.load = true;
      this.$emit("complete", true);
      if (res.code == 0) {
        this.banner = res.data.banner;
        this.list = res.data.list;
      }
      setTimeout(() => {
        document.getElementById("footer-faq-link").classList.add("is-active");
      }, 100);
    });
  },
  mounted() {
    document.getElementById("faq-top-action").classList.add("is-active");
  },
};
</script>
<style lang='less' scoped>
.formInfo {
  margin-top: 2rem;
  input {
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  [type="date"] {
    border: none;
  }
  .column {
    text-align: center;
    .button {
      margin: 0 2rem;
    }
  }
  .title {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    text-align: center;
  }
}
.banner {
  width: 100%;
  img {
    width: 100%;
    height: 43vw;
  }
}
.item-title {
  background: #000;
  color: #fff;
  padding: 2rem 3.125rem;
  h2 {
    margin-bottom: 0;
  }
}
.faq-list {
  margin: 0;
  &:nth-child(even) {
    background: #f7f7f7;
  }
  .column {
    padding-left: 0;
    padding-right: 0;
  }
  .right-text {
    padding: 3rem;

    .title {
      width: fit-content;
      border-top: 4px solid #e77500;
    }
    h3 {
      margin: 1rem 0;
    }
  }
}
.info {
  .row {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-around;
    align-items: center;
    input {
      width: 40%;
      border: none;
    }
  }
}
@media print, screen and (max-width: 40em) {
  .item-title {
    padding: 1rem 0.925rem;
    h2 {
      font-size: 1.3rem;
    }
  }
  .faq-list img {
    width: 100%;
    // max-height: 43vw;
  }
  .faq-list .right-text {
    padding: 0 1rem;
    .title {
      display: none;
    }
  }
  .formInfo {
    padding: 0 1rem;
  }
}
</style>
<style lang="less">
@media print, screen and (min-width: 40em) {
  .ant-form {
    .ant-row {
      display: flex;
      justify-content: center;
    }
  }
}
@media print, screen and (max-width: 40em) {
  .ant-form-item-label {
    width: 100%;
  }
  .ant-form-item-control-wrapper {
    width: 100%;
  }
  .ant-col-offset-4 {
    margin-left: 0;
  }
  .action-btn {
    .button {
      margin: 0 1rem !important;
    }
  }
  h3 {
    font-size: 1.3rem;
  }
  p {
    text-align: justify;
  }
}
</style>